export default {
  "app.aboutus.beginners_guide": "新手指引",
  "app.aboutus.capital_allocation_guide": "配资指南",
  "app.aboutus.company_qualification": "公司资质",
  "app.aboutus.contact_us": "联系我们",
  "app.aboutus.help_center": "帮助中心",
  "app.aboutus.registeration_agreement": "注册协议",
  "app.aboutus.title": "关于我们",
  "app.aboutus.trading_rules": "交易规则",
  "app.account_details.addFund": "追加配资",
  "app.account_details.addMar": "追加保证金",
  "app.account_details.applyAmount": "申请额度",
  "app.account_details.applysettle": "申请结算",
  "app.account_details.applysettle1": "您是否确定结算该合约?",
  "app.account_details.availablecredit": "可用额度(美元)",
  "app.account_details.currentPL": "当前盈亏(美元)",
  "app.account_details.days": "已操盘天数",
  "app.account_details.funddetail": "资金明细",
  "app.account_details.holdingRatio": "持仓比例",
  "app.account_details.lossstop": "亏损平仓线",
  "app.account_details.losswarn": "亏损警戒线",
  "app.account_details.managefee": "账户管理费",
  "app.account_details.marketHolding": "持仓市值(美元)",
  "app.account_details.more": "更多操作",
  "app.account_details.order": "交易委托",
  "app.account_details.revenuesh": "收益分成",
  "app.account_details.riskMargin": "风险保证金",
  "app.account_details.title": "账户详情",
  "app.account_details.toUpdate": "点击更新",
  "app.account_details.totalAsset": "合约总资产(美元)",
  "app.account_details.totalCap": "总配资资金",
  "app.activity.title": "活动专区",
  "app.activitydetail.title": "活动详情",
  "app.agency.agent_level1": "一级代理",
  "app.agency.agent_level2": "二级代理",
  "app.agency.agent_level3": "三级代理",
  "app.agency.commision": "佣金金额",
  "app.agency.deferred": "递延费总额",
  "app.agency.management": "管理费总额",
  "app.agency.profit": "利润分成总额",
  "app.agency.promo": "推广链接",
  "app.agency.recharge": "会员充值奖励",
  "app.agency.team": "我的团队",
  "app.agency.title": "推广账户",
  "app.agency.transfer": "资金提现划转",
  "app.agency.withdraw": "提取总额",
  "app.agency_link.copycode": "复制推广码",
  "app.agency_link.copylink": "复制链接",
  "app.agency_link.method1": "方法一：扫描二维码",
  "app.agency_link.method2": "方法二：点击链接注册",
  "app.agency_link.method3": "方法三：注册页面输入推广码",
  "app.agency_link.myQR": "我的二维码",
  "app.agency_link.title": "我的推广链接",
  "app.agent_commision_detail.accNum": "账号: ",
  "app.agent_commision_detail.amount": "金额: ",
  "app.agent_commision_detail.balance": "余额: ",
  "app.agent_commision_detail.title": "佣金分成",
  "app.agent_transfer_withdrawal.accBalance": "账户余额",
  "app.agent_transfer_withdrawal.dsc": "资金划转：资金从推广账户划转到会员账户，即时到账。",
  "app.agent_transfer_withdrawal.title": "提现/划转",
  "app.agent_transfer_withdrawal.transfer": "划转",
  "app.agent_transfer_withdrawal.transferAm": "提现/划转金额",
  "app.agent_transfer_withdrawal.transferAm_placeholder": "请输入划转金额",
  "app.agent_transfer_withdrawal.transfer_sure": "Are you sure want to Transfer ",
  "app.agent_transfer_withdrawal.transfer_sure1": "资金到您的会员账号? ",
  "app.agent_transfer_withdrawal.transfer_title": "确认划转",
  "app.agent_transfer_withdrawal.warn1": "您输入的金额有误",
  "app.agent_transfer_withdrawal.withdraw": "提现",
  "app.agent_transfer_withdrawal.withdraw_sure": "您是否确定提现",
  "app.agent_transfer_withdrawal.withdraw_title": "确认提现",
  "app.agent_withdraw_details.amount": "金额: ",
  "app.agent_withdraw_details.balance": "余额: ",
  "app.agent_withdraw_details.title": "提取总额",
  "app.announcement.title": "平台公告",
  "app.bind_bank.bank": "开户行全称",
  "app.bind_bank.bank_address": "开户行地址",
  "app.bind_bank.bank_address_dsc": "请填写开户行地址",
  "app.bind_bank.bank_select": "点击选择开户行全称",
  "app.bind_bank.bank_select_dsc": "请选择开户行",
  "app.bind_bank.card": "银行卡卡号",
  "app.bind_bank.card_dsc": "请填写银行卡卡号",
  "app.bind_bank.name": "开户人姓名",
  "app.bind_bank.name_dsc": "请填写姓名",
  "app.bind_bank.title": "绑定银行卡",
  "app.bind_email.email": "请输入邮箱",
  "app.bind_email.email_placeholder": "请输入您要更改的邮箱",
  "app.bind_email.get_code": "获取验证码",
  "app.bind_email.sms_verification": "短信验证码",
  "app.bind_email.sms_verification_placeholder": "请输入您新邮箱收到的验证码",
  "app.bind_email.title": "邮箱",
  "app.bind_phone.current_mobile": "当前手机号",
  "app.bind_phone.get_code": "获取验证码",
  "app.bind_phone.new_mobile": "新手机号",
  "app.bind_phone.new_mobile_dsc": "请填写新手机号",
  "app.bind_phone.sms_verification": "短信验证码",
  "app.bind_phone.sms_verification_dsc": "请填写验证码",
  "app.bind_phone.sms_verification_placeholder": "请输入短信验证码",
  "app.bind_phone.title": "更换手机号",
  "app.capital_fund_details.title": "资金明细",
  "app.capitalaccount.balance": "可用余额",
  "app.capitalaccount.create_capital": "配资",
  "app.capitalaccount.cumulative_profit_loss": "累计盈亏",
  "app.capitalaccount.current_capital": "当前配资",
  "app.capitalaccount.history_capital": "历史配资",
  "app.capitalaccount.information": "账户信息",
  "app.capitalaccount.loss_liquidation": "亏损平仓线",
  "app.capitalaccount.loss_warning": "亏损警戒线",
  "app.capitalaccount.profit_loss": "浮动盈亏",
  "app.capitalaccount.risk_margin": "风险保证金",
  "app.capitalaccount.short_trading": "做空交易",
  "app.capitalaccount.title": "配资交易",
  "app.capitalaccount.total_asset": "当前总资产",
  "app.capitalaccount.total_capital_allocation": "总配资资金",
  "app.capitalaccount.trade_capital": "交易",
  "app.capitalaccount.trading": "做多交易",
  "app.channelroom.pw_error": "密码错误",
  "app.channelroomuser.error_sending": "信息发送错误，请重试",
  "app.channelsearch.pw_error": "密码错误",
  "app.closed_Capital_info.application_amount": "申请额度",
  "app.closed_Capital_info.buy_sell_sts": "买卖/状态",
  "app.closed_Capital_info.contactnum": "合同编号",
  "app.closed_Capital_info.deduction": "扣减",
  "app.closed_Capital_info.distribution_profit_loss": "交易盈亏分配",
  "app.closed_Capital_info.freez": "冻结",
  "app.closed_Capital_info.loss_compension": "亏损赔付",
  "app.closed_Capital_info.loss_stop_line": "亏损平仓线",
  "app.closed_Capital_info.loss_warning_line": "亏损警戒线",
  "app.closed_Capital_info.management_fee": "管理费",
  "app.closed_Capital_info.margin_settlement": "保证金结算",
  "app.closed_Capital_info.namecode": "名称代码",
  "app.closed_Capital_info.price_qty": "价格/数量",
  "app.closed_Capital_info.profit_dist": "盈利分配",
  "app.closed_Capital_info.profit_loss_ratio": "盈亏比例",
  "app.closed_Capital_info.revenue_sharing": "收益分成",
  "app.closed_Capital_info.risk_margin": "风险保证金",
  "app.closed_Capital_info.thaw": "解冻",
  "app.closed_Capital_info.time": "成交时间",
  "app.closed_Capital_info.title": "历史操盘",
  "app.closed_Capital_info.total_capital_allocation": "总配资资金",
  "app.closed_Capital_info.total_trade_capital": "总操盘资金",
  "app.closed_Capital_info.trade_instrument": "交易品种",
  "app.closed_Capital_info.trade_profit_loss": "交易盈亏",
  "app.closed_Capital_info.transaction_flow": "交易流水(点击查看更多明细)",
  "app.common.account": "账户",
  "app.common.back": "返回",
  "app.common.cancel": "取消",
  "app.common.chat": "专属客服",
  "app.common.confirm": "确认",
  "app.common.currency": "美元",
  "app.common.enter_sms_code": "请输入验证码",
  "app.common.finished": "没有更多了",
  "app.common.home": "首页",
  "app.common.loading": "加载中...",
  "app.common.not_logged_in": "您还未登录",
  "app.common.phone_wrong_format": "手机号格式不正确",
  "app.common.phone_wrong_format2": "两次密码不相同,请重新输入",
  "app.common.stock": "行情自选",
  "app.common.sure": "确定",
  "app.common.trade": "配资交易",
  "app.createcapital.Agreement": "《金牛美股有限公司服务协议》",
  "app.createcapital.account_balance": "账户余额 :",
  "app.createcapital.apply_amount": "申请额度",
  "app.createcapital.apply_btn": "立即申请",
  "app.createcapital.auto_extension": "自动延期",
  "app.createcapital.capital": "交易",
  "app.createcapital.capital_info": "最少2千,最多200万,1百整倍数",
  "app.createcapital.capital_info_vip": "最少10万,最多500万,1百整倍数",
  "app.createcapital.consent": "申请即默认同意",
  "app.createcapital.create_capital": "配资",
  "app.createcapital.daily_interest_rate": "日利率",
  "app.createcapital.day_capital": "按天配资",
  "app.createcapital.day_contract": "每个合约至少交易",
  "app.createcapital.day_contract2": " 个交易日",
  "app.createcapital.day_contract3": " 首次申请将扣取2个交易日的管理费",
  "app.createcapital.funds_plus_margin": "配资资金+保证金",
  "app.createcapital.holding_time": "持仓时间",
  "app.createcapital.interest_free_capital": "免息配资",
  "app.createcapital.interest_free_rate": "免息",
  "app.createcapital.login_first": "请先登录",
  "app.createcapital.loss_line": "亏损平仓线",
  "app.createcapital.loss_warning": "亏损警戒线",
  "app.createcapital.month_capital": "按月配资",
  "app.createcapital.month_interest_rate": "月利息",
  "app.createcapital.pre_management_fee": "预存管理费",
  "app.createcapital.pre_management_fee_calc_day": "配资额×日利率×2",
  "app.createcapital.pre_management_fee_calc_month": "配资额x月利率",
  "app.createcapital.pre_management_fee_calc_week": "配资额x周利率",
  "app.createcapital.pull_refresh": "下拉刷新",
  "app.createcapital.read_agreement": "请先阅读协议书",
  "app.createcapital.refresh": "刷新",
  "app.createcapital.risk_margin": "风险保证金",
  "app.createcapital.times": "倍",
  "app.createcapital.title": "配资交易",
  "app.createcapital.total_capital": "总配资资金",
  "app.createcapital.total_payable": "共应支付 :",
  "app.createcapital.trading_day": "交易日",
  "app.createcapital.trading_month": "自然月",
  "app.createcapital.trading_type": "操盘类型",
  "app.createcapital.trading_week": "周",
  "app.createcapital.undestand": "我已经明白",
  "app.createcapital.upto_30_days": "最长30天",
  "app.createcapital.vip_capital": "VIP配资",
  "app.createcapital.voucher_balance": "代金券 :",
  "app.createcapital.week_capital": "按周配资",
  "app.createcapital.week_interest_rate": "周利息",
  "app.deal_inquiry.amount": "成交金额",
  "app.deal_inquiry.buy": "买入额:",
  "app.deal_inquiry.commision": "券商佣金",
  "app.deal_inquiry.date": "历史成交:",
  "app.deal_inquiry.delivery": "结算交收费",
  "app.deal_inquiry.direction": "交易方向",
  "app.deal_inquiry.directionTrade": "多头/空头",
  "app.deal_inquiry.fees": "交易费",
  "app.deal_inquiry.frc": "财汇局交易征费",
  "app.deal_inquiry.levy": "交易征费",
  "app.deal_inquiry.name": "名称代码",
  "app.deal_inquiry.pltFee": "平台费用",
  "app.deal_inquiry.price": "成交价格",
  "app.deal_inquiry.qty": "成交数量",
  "app.deal_inquiry.search": "查询",
  "app.deal_inquiry.select_date": "选择年月日",
  "app.deal_inquiry.sell": "卖出额:",
  "app.deal_inquiry.stamp": "印花税",
  "app.deal_inquiry.time": "成交时间",
  "app.deal_inquiry.title": "成交查询",
  "app.deferred_cost.accNum": "账号: ",
  "app.deferred_cost.amount": "金额: ",
  "app.deferred_cost.balance": "余额: ",
  "app.deferred_cost.title": "递延费明细",
  "app.detailed_log.all_detail": "全部明细",
  "app.detailed_log.balance": "余额",
  "app.detailed_log.cash_back": "赠返现金",
  "app.detailed_log.depositl": "充值明细",
  "app.detailed_log.loan": "借款明细",
  "app.detailed_log.management_fee": "管理费用",
  "app.detailed_log.profit_withdraw": "利润提取",
  "app.detailed_log.title": "资金明细",
  "app.detailed_log.voucher": "代金券",
  "app.detailed_log.withdraw": "提现明细",
  "app.divided_cost.accNum": "账号: ",
  "app.divided_cost.amount": "金额: ",
  "app.divided_cost.balance": "余额: ",
  "app.divided_cost.title": "利润分成明细",
  "app.entrust_inquiry.buy_sell": "买卖",
  "app.entrust_inquiry.buy_sell_state": "状态",
  "app.entrust_inquiry.code": "代码",
  "app.entrust_inquiry.commision_price": "委托价格",
  "app.entrust_inquiry.date": "委托日期 :",
  "app.entrust_inquiry.direction": "多头/空头",
  "app.entrust_inquiry.order_qty": "委托数量",
  "app.entrust_inquiry.order_time": "委托时间",
  "app.entrust_inquiry.search": "查询",
  "app.entrust_inquiry.select_date": "选择年月日",
  "app.entrust_inquiry.stock": "股票",
  "app.entrust_inquiry.title": "委托查询",
  "app.entrust_inquiry.transaction_price": "成交价格",
  "app.entrust_inquiry.transaction_qty": "成交数量",
  "app.entrust_inquiry.transaction_time": "成交时间",
  "app.financefund.incorect_amount": "填写金额不正确",
  "app.forget.card": "身份证号码：",
  "app.forget.card_placeholder": "请输入您的卡",
  "app.forget.complete": "完成",
  "app.forget.forgetpass": "忘记密码",
  "app.forget.get_code": "获取验证码",
  "app.forget.get_code_placeholder": "请输入短信验证码",
  "app.forget.get_code_sms": "短信验证码",
  "app.forget.password": "新密码",
  "app.forget.passwordConfirm": "再次新密码",
  "app.forget.passwordConfirm_placeholder": "在次输入新密码",
  "app.forget.password_placeholder": "请输入新密码",
  "app.forget.phone": "手机号",
  "app.forget.phone_placeholder": "请输入手机号",
  "app.forget.real_name": "姓名：",
  "app.forget.real_name_placeholder": "请输入您的真实姓名",
  "app.forget.verification_code": "验证码",
  "app.forget.verification_code_placeholder": "请输入验证码",
  "app.foundwinner.change_price": "最大涨幅",
  "app.foundwinner.focus_price": "关注价",
  "app.foundwinner.high_price": "最高价",
  "app.foundwinner.last_15_days": "近15日涨幅排行榜",
  "app.foundwinner.latestStockPool": "最新股票池",
  "app.foundwinner.login_to_access": "您还未登录,前去登录",
  "app.foundwinner.more": "更多",
  "app.foundwinner.regiter_to_read": "注册登陆可读",
  "app.foundwinner.stock_name": "股票名",
  "app.friend_coupon.amount": "金额",
  "app.friend_coupon.balance": "余额:",
  "app.friend_coupon.code": "推广二维码/链接",
  "app.friend_coupon.details": "详情",
  "app.friend_coupon.dsc": "暂无好友现金券",
  "app.friend_coupon.expdate": "到期日期",
  "app.friend_coupon.giftdate": "赠送日期",
  "app.friend_coupon.instruction": "使用须知",
  "app.friend_coupon.status": "状态",
  "app.friend_coupon.title": "好友现金券",
  "app.fund_details.title": "资金明细",
  "app.home.about_us": "关于我们",
  "app.home.activity_zone": "活动专区",
  "app.home.app_download": "APP下载",
  "app.home.app_download1": "安全配资 上金牛美股",
  "app.home.app_download2": "知名品牌券商",
  "app.home.copyright": "投资有风险，入市需谨慎）",
  "app.home.day_capital": "按天配资",
  "app.home.error": "加载失败",
  "app.home.found_winner": "发现牛股",
  "app.home.interest_free_capital": "免息配资",
  "app.home.market_info": "股市资讯",
  "app.home.month_capital": "按月配资",
  "app.home.more": "更多",
  "app.home.online_customer_service": "在线客服",
  "app.home.week_capital": "按周配资",
  "app.increase_bond_info.add": "追加保证金金额",
  "app.increase_bond_info.add_aftr": "追加后总账户余额 ：",
  "app.increase_bond_info.add_immediate": "立即追加",
  "app.increase_bond_info.add_min": "最低追加金额",
  "app.increase_bond_info.add_plh": "请输入追加金额 最低100美元起",
  "app.increase_bond_info.bal": "当前余额",
  "app.increase_bond_info.num": "合约编号",
  "app.increase_bond_info.title": "追加保证金",
  "app.increase_bond_info.toalBal": "当前总账户余额 ：",
  "app.increase_bond_info.warn1": "请输入追加金额",
  "app.increase_capital_info.add": "追加配资金额",
  "app.increase_capital_info.add_aftr": "追加后总账户余额 ：",
  "app.increase_capital_info.add_immediate": "立即追加",
  "app.increase_capital_info.add_min": "最低追加金额",
  "app.increase_capital_info.add_plh": "请输入追加金额 最低100美元起",
  "app.increase_capital_info.bal": "当前余额",
  "app.increase_capital_info.num": "合约编号",
  "app.increase_capital_info.title": "追加配资",
  "app.increase_capital_info.toalBal": "当前总账户余额 ：",
  "app.increase_capital_info.warn1": "请输入追加金额",
  "app.information.bank_card": "银行卡",
  "app.information.bound": "已绑定银行卡",
  "app.information.email": "邮箱",
  "app.information.login_pass": "登录密码",
  "app.information.nick_name": "昵称",
  "app.information.nobound": "未绑定",
  "app.information.notset": "未设置",
  "app.information.password": "密码",
  "app.information.phone": "手机",
  "app.information.real_name": "实名认证",
  "app.information.set": "已设置",
  "app.information.title": "完善资料",
  "app.information.unname": "未实名",
  "app.information.withdraw_pass": "提款密码",
  "app.kline.PE": "市盈/静",
  "app.kline.amplitude": "振幅",
  "app.kline.billion": "亿",
  "app.kline.buy": "买入",
  "app.kline.circulation": "流通值",
  "app.kline.commision_ratio": "委比",
  "app.kline.day": "日K",
  "app.kline.favourite": "自选",
  "app.kline.highest": "最高",
  "app.kline.in_hand": "手",
  "app.kline.in_hand_10": "万手",
  "app.kline.in_hand_100": "亿手",
  "app.kline.low": "最低",
  "app.kline.minute": "分钟",
  "app.kline.month": "月K",
  "app.kline.points": "分",
  "app.kline.price_lm": "股息率",
  "app.kline.sell": "卖出",
  "app.kline.thousand": "万",
  "app.kline.timeshare": "分时",
  "app.kline.today_open": "今开",
  "app.kline.total_market": "总市值",
  "app.kline.trade_volume": "成交量",
  "app.kline.trans_volume": "成交额",
  "app.kline.volume_drop": "52周高",
  "app.kline.volume_ratio": "52周低",
  "app.kline.week": "周K",
  "app.kline.yesterday_harvest": "昨收",
  "app.login.forgetpass": "忘记密码?",
  "app.login.login": "登录",
  "app.login.password": "密码",
  "app.login.password_placeholder": "请输入密码",
  "app.login.phone_number": "手机号",
  "app.login.phone_number_placeholder": "请输入手机号",
  "app.login.register": "立即注册",
  "app.login_pass.confirm_pass": "确认密码",
  "app.login_pass.confirm_pass_dsc": "请输入确认密码",
  "app.login_pass.get_code": "获取验证码",
  "app.login_pass.login_pass": "输入密码",
  "app.login_pass.login_pass_dsc": "请输入密码",
  "app.login_pass.password_not_identical": "密码不一致,请重新输入",
  "app.login_pass.phone": "手机号",
  "app.login_pass.sms_verification": "短信验证码",
  "app.login_pass.sms_verification_dsc": "请填写验证码",
  "app.login_pass.sms_verification_placeholder": "请输入短信验证码",
  "app.login_pass.title": "修改登录密码",
  "app.login_pass.verification": "验证码",
  "app.login_pass.verification_placeholder": "请输入验证码",
  "app.manage_cost.accNum": "账号: ",
  "app.manage_cost.amount": "金额: ",
  "app.manage_cost.balance": "余额: ",
  "app.manage_cost.title": "管理费明细",
  "app.members.agent_account": "推广账号",
  "app.members.announcement": "平台公告",
  "app.members.balance": "余额",
  "app.members.capital_account": "配资账户",
  "app.members.checkIn": "签到",
  "app.members.create_capital": "申请配资",
  "app.members.customer_service": "联系客服",
  "app.members.deal_log": "成交查询",
  "app.members.depot_log": "持仓查询",
  "app.members.entrust_log": "委托查询",
  "app.members.first_recharge": "首充礼品清单",
  "app.members.first_recharge_now": "立即充值",
  "app.members.friend_cash_coupon": "好友现金券",
  "app.members.fundingDetails": "资金明细",
  "app.members.gxpay_desc": "(第三方数字货币合作机构)",
  "app.members.holiday_treasure": "节日宝",
  "app.members.immediate_trading": "立即配资交易",
  "app.members.line1": "线路 1",
  "app.members.line2": "线路 2",
  "app.members.line3": "线路 3",
  "app.members.line_switch": "线路切换",
  "app.members.live_trade": "实盘交易",
  "app.members.login": "登录",
  "app.members.logout": "退出登录",
  "app.members.margin": "保证金",
  "app.members.my_cash_coupon": "我的好友现金券",
  "app.members.personal_info": "完善个人资料",
  "app.members.quotes": "自选股票",
  "app.members.realname_pop": "您还没有实名",
  "app.members.realname_pop_bonus": "美元礼金",
  "app.members.realname_pop_cancel": "取消",
  "app.members.realname_pop_real": "立即实名",
  "app.members.realname_pop_reg": "请实名激活",
  "app.members.recharge": "充值",
  "app.members.register": "注册",
  "app.members.regular_treasure": "定期宝",
  "app.members.risk_control": "风控通知",
  "app.members.timebao": "时时宝",
  "app.members.timebao_desc": "炒股理财时时赚钱 年化收益",
  "app.members.title": "会员中心",
  "app.members.totalprofit": "累计收益",
  "app.members.version": "版本号 / 包号",
  "app.members.voucher": "代金券",
  "app.members.withdraw": "提现",
  "app.members.withdraw_log": "撤单查询",
  "app.my_team.all_members": "所有会员",
  "app.my_team.title": "我的团队",
  "app.my_team.total_topup": "充值总额:",
  "app.my_team.total_topup_membership": "充值会员",
  "app.my_team.total_topup_non_membership": "无充值会员",
  "app.news_info.error": "加载失败",
  "app.news_info.title": "新闻资讯",
  "app.news_info_detailed.publisher": "发布者 : ",
  "app.news_info_detailed.title": "新闻资讯",
  "app.nickname.enter_nick_name": "请填写昵称",
  "app.nickname.nick_name": "昵称",
  "app.nickname.title": "修改昵称",
  "app.notice_detailed.title": "公告详情",
  "app.position_inquiry.code": "名称代码",
  "app.position_inquiry.cost": "成本价",
  "app.position_inquiry.direction": "多头/空头",
  "app.position_inquiry.frozen": "冻结数量",
  "app.position_inquiry.holding": "总持仓数",
  "app.position_inquiry.market": "持仓市值",
  "app.position_inquiry.number": "合约号",
  "app.position_inquiry.openday": "开仓日",
  "app.position_inquiry.price": "当前价",
  "app.position_inquiry.profitloss": "浮动盈亏",
  "app.position_inquiry.sellable": "可卖数量",
  "app.position_inquiry.title": "持仓查询",
  "app.protocol.title": "协议",
  "app.protocol.wrong_entry": "非法进入",
  "app.quotes.all": "全部美股",
  "app.quotes.code": "名称代码",
  "app.quotes.latest_price": "最新价",
  "app.quotes.optional": "自选",
  "app.quotes.price_change": "涨跌",
  "app.quotes.title": "行情",
  "app.quotes.trading_volume": "成交量",
  "app.quotes_detail.latest_price": "最新价",
  "app.quotes_detail.name": "代码/名称",
  "app.quotes_detail.rise": "涨跌幅",
  "app.quotes_detail.title1": "全部美股",
  "app.quotes_detail.title2": "热门港股",
  "app.quotes_detail.title3": "港股涨幅",
  "app.quotes_detail.title4": "港股跌幅",
  "app.quotes_detail.title5": "港股成交额",
  "app.quotes_detail.title6": "港股成交量",
  "app.quotes_detail.volume1": "成交额/万",
  "app.quotes_detail.volume2": "成交量/万",
  "app.real_name.first_recharge_gift": "首充礼品清单",
  "app.real_name.first_recharge_gift_cancel": "取消",
  "app.real_name.first_recharge_gift_recharge": "立即充值",
  "app.real_name.id_card": "身份证",
  "app.real_name.id_card_msg": "请填写身份证",
  "app.real_name.real_name": "姓名",
  "app.real_name.real_name_msg": "请填写真实姓名",
  "app.real_name.title": "实名认证",
  "app.recharge.activityzone": "活动专区",
  "app.recharge.amount_rmb": "充值金额（人民币）",
  "app.recharge.current_balance": "当前余额： ",
  "app.recharge.dollar": "美币",
  "app.recharge.exchangeamt": "兑换金额：",
  "app.recharge.exchangefee": "兑换费用：",
  "app.recharge.instruction": "充值须知",
  "app.recharge.instruction1": "请务保留旧卡转账，会造成无法充值。",
  "app.recharge.instruction2": "请务必以券商制定的试试入款卡为准。",
  "app.recharge.invalid": "请输入正确的充值金额",
  "app.recharge.invalid100": "充值金额必须为大于100元",
  "app.recharge.maxlimit": "人工入款金额最大金额为200万",
  "app.recharge.next": "下一步",
  "app.recharge.next1": "获取实时入款卡，请自行通过手机/电脑/银行转账",
  "app.recharge.placeholder": "请输入充值金额，100元人民币起",
  "app.recharge.ratio": "美币:人民币 = ",
  "app.recharge.rmb1": "人民币 ( ",
  "app.recharge.rmb2": " 人民币起 )",
  "app.recharge.title": "充值",
  "app.recharge.type": "充值类型",
  "app.recharge.undestand": "我已经明白",
  "app.recharge.yuan": "元",
  "app.recharge_info.acc_name": "开户名称:",
  "app.recharge_info.addr": "收款地址: ",
  "app.recharge_info.bank": "收款银行:",
  "app.recharge_info.card": "收款卡号:",
  "app.recharge_info.copies": "复制成功",
  "app.recharge_info.copy": "复制",
  "app.recharge_info.ins": "充值须知:",
  "app.recharge_info.ins1": "1. 请勿保留旧卡转账，会造成无法充值。",
  "app.recharge_info.ins2": "2. 请用本人账号自行通过手机/电脑/银行向以下账号转账。",
  "app.recharge_info.ins3": "3. 转账成功后点“我已转账，申请充值”，平台确认后到账。",
  "app.recharge_info.ins4": "使用说明:",
  "app.recharge_info.ins5": "转账后3-10分钟充值到账，如未到账，请联系在线客服或专属客服处理。",
  "app.recharge_info.pay_amt": "付款金额:",
  "app.recharge_info.recharge": "充值",
  "app.recharge_info.reminder": "温馨提醒：",
  "app.recharge_info.reminder1": "请用本人 ( ",
  "app.recharge_info.reminder2": " ) 的账号自行转账后点《我已成功付款》，即可入款\n转账金额须与系统一致，若有小数须带小数，否则次日到账",
  "app.recharge_info.success": "充值申请成功,尽快完成后续操作,联系客服吧",
  "app.recharge_info.title": "银行卡信息",
  "app.recharge_info.wrong_entry": "非法进入",
  "app.register.first_deposit": "首充",
  "app.register.get_code": "获取验证码",
  "app.register.gift_money": "美元礼金",
  "app.register.loginNow": "立即登录",
  "app.register.login_to_receive": "请登录领取",
  "app.register.newMember_gift": "新会员最高专享礼",
  "app.register.newMember_gift1": "~最高可领~",
  "app.register.newMember_gift1_1": "豪礼一：新用户注册送",
  "app.register.password": "设置密码",
  "app.register.password_placeolder": "请输入密码",
  "app.register.phone": "手机号码",
  "app.register.phone_placeholder": "请输入手机号",
  "app.register.recommender": "推荐人",
  "app.register.recommender_placeholder": "请输入推荐人",
  "app.register.register": "注册",
  "app.register.sms_code": "短信验证码",
  "app.register.sms_code_placeholder": "请输入短信验证码",
  "app.register.success": "您已注册成功",
  "app.register.verification_code": "验证码",
  "app.register.verification_code_placeholder": "请输入验证码",
  "app.risk_control.title": "风控通知",
  "app.timebao.annual_int": "年化利率",
  "app.timebao.balance": "账户余额",
  "app.timebao.bill": "账单",
  "app.timebao.cumulate_income": "累计收益",
  "app.timebao.current_asset": "当前资产",
  "app.timebao.last_8_hr": "上8小时收益",
  "app.timebao.title": "时时宝",
  "app.timebao.transfer": "转入时时宝",
  "app.timebao.transferAm": "转入金额 :",
  "app.timebao.transfer_from": "从时时宝转出",
  "app.timebao.transfer_in": "转入",
  "app.timebao.transfer_out": "转出",
  "app.timebao.transferable": "可转余额:",
  "app.timebao.transferring": "转出金额:",
  "app.timebao.warning": "请输入正确金额",
  "app.timebao_detail.balance": "账户余额:",
  "app.timebao_detail.date": "日期:",
  "app.timebao_detail.finish": "没有更多了",
  "app.timebao_detail.search": "检索",
  "app.timebao_detail.selectDate": "选择年月日",
  "app.timebao_detail.title": "资金明细",
  "app.trading.1/3": "1/3仓",
  "app.trading.availablebuy": "可开",
  "app.trading.availablesell": "可平",
  "app.trading.balance": "余额:",
  "app.trading.buy": "开仓",
  "app.trading.buy1": "买1",
  "app.trading.confirm": "确认交易",
  "app.trading.dealpop_amt": "成交金额",
  "app.trading.dealpop_code": "股票代码",
  "app.trading.dealpop_commision": "券商佣金",
  "app.trading.dealpop_delivery_fee": "结算交收费",
  "app.trading.dealpop_fee": "交易费",
  "app.trading.dealpop_frc": "财汇局交易征费",
  "app.trading.dealpop_levy": "交易征费",
  "app.trading.dealpop_name": "业务名称",
  "app.trading.dealpop_plt_fee": "平台费用",
  "app.trading.dealpop_price": "成交价格",
  "app.trading.dealpop_qty": "成交数量",
  "app.trading.dealpop_stamp": "印花税",
  "app.trading.dealpop_sum": "总金额",
  "app.trading.dealpop_time": "日期时间",
  "app.trading.empty": "平空",
  "app.trading.full": "全仓",
  "app.trading.half": "半仓",
  "app.trading.limitprice": "限价",
  "app.trading.market": "行情",
  "app.trading.market_buy": "市价",
  "app.trading.market_sell": "市价",
  "app.trading.marketprice": "市价",
  "app.trading.sell": "平仓",
  "app.trading.sell1": "卖1",
  "app.trading.short": "做空",
  "app.trading.trade": "做多交易",
  "app.trading.tradeD": "做空交易",
  "app.trading.undestand": "我已经明白",
  "app.trading.warn1": "当前股价最小单位为 ",
  "app.trading.warn2": "请输入股票交易价格",
  "app.trading.warn3": "请输入交易股票代码 ",
  "app.trading.warn4": "请输入股票交易数量",
  "app.trading.warn5": "您是否确定买入该股票?",
  "app.trading.warn6": "您是否确认卖出该股票?",
  "app.trading.warn7": "您将要撤销该股票，是否继续？",
  "app.trading.warn8": "还没有有配资合约，请先完成配资",
  "app.tradingColumns.buy_sell_qty": "买卖/数量",
  "app.tradingColumns.cancel": "撤单",
  "app.tradingColumns.commision_time": "委托时间",
  "app.tradingColumns.deal": "成交",
  "app.tradingColumns.delegation_status": "委托/状态",
  "app.tradingColumns.entrust": "委托",
  "app.tradingColumns.entrust_transaction": "委托/成交",
  "app.tradingColumns.fee": "手续费",
  "app.tradingColumns.market_value": "持仓市值",
  "app.tradingColumns.name": "名称代码",
  "app.tradingColumns.position": "持仓",
  "app.tradingColumns.position_available": "持仓/可用",
  "app.tradingColumns.position_availablesell": "持仓/可卖",
  "app.tradingColumns.price_cost": "现价/成本",
  "app.tradingColumns.price_total": "价格/总额",
  "app.tradingColumns.profit_loss": "浮动盈亏",
  "app.user_coupon.date": "有效期: ",
  "app.user_coupon.dsc": "暂无我的现金券",
  "app.user_coupon.p1": "现金券: 充值满 ",
  "app.user_coupon.p2": "要求 配资后买入额达到 ",
  "app.user_coupon.p3": "美元后可提现 ",
  "app.user_coupon.title": "我的现金券",
  "app.user_coupon.use": "去使用",
  "app.voucher_cost.accNum": "账号: ",
  "app.voucher_cost.amount": "金额: ",
  "app.voucher_cost.balance": "余额: ",
  "app.voucher_cost.title": "会员充值奖励",
  "app.withdraw.accInfo": "账户信息",
  "app.withdraw.amt": "提现金额：",
  "app.withdraw.amt_plh": "最少提现100元",
  "app.withdraw.bankb": "还未绑定银行卡,请前去绑定银行卡才可提现",
  "app.withdraw.cancel": "非新提现",
  "app.withdraw.changePW": "修改提现密码",
  "app.withdraw.confirm": "确认提现",
  "app.withdraw.continue": "继续新提现",
  "app.withdraw.curBal": "当前余额：",
  "app.withdraw.currency": "提现币种（人民币）",
  "app.withdraw.exchange": "兑换金额: ",
  "app.withdraw.gx_plh": "请输入Gxpay ID",
  "app.withdraw.popup": "您还没有设置提现密码，不能提现，请前去设置",
  "app.withdraw.popup2": "请先设置提现银行卡才能提现",
  "app.withdraw.pwd": "提现密码： ",
  "app.withdraw.pwd_plh": "请输入提现密码",
  "app.withdraw.ratio": "人民币:美币=",
  "app.withdraw.reminder": "友情提醒",
  "app.withdraw.reminder1": "转入时时宝, 每8小时收益",
  "app.withdraw.reminder2": "%开市炒股，休市理财，时时赚钱 随进随出，实时到账，年化收益率",
  "app.withdraw.reminder3": "转入时时宝",
  "app.withdraw.reminder4": "继续提现",
  "app.withdraw.reminder_first": "温馨提醒：",
  "app.withdraw.rmb": "人民币",
  "app.withdraw.same": "您已提交一笔同金额的提现正在审核处理中\n若非新提现请勿重复提交 提示",
  "app.withdraw.select": "请选择提款类型",
  "app.withdraw.success": "提现成功",
  "app.withdraw.title": "提现",
  "app.withdraw.undestand": "我已经明白",
  "app.withdraw.verified": "已核对确认",
  "app.withdraw.warn1": "请输入提现金额",
  "app.withdraw.warn2": "请输入提现密码",
  "app.withdraw.warn3": "请输入您的GXPay ID",
  "app.withdraw.warn4": "请核对您的Gxpay ID 后再确认提现操作",
  "app.withdraw_pass.confirm_pass": "确认密码",
  "app.withdraw_pass.confirm_pass_dsc": "请输入确认密码",
  "app.withdraw_pass.get_code": "获取验证码",
  "app.withdraw_pass.phone": "手机号",
  "app.withdraw_pass.sms_verification": "短信验证码",
  "app.withdraw_pass.sms_verification_dsc": "请填写验证码",
  "app.withdraw_pass.sms_verification_placeholder": "请输入短信验证码",
  "app.withdraw_pass.title": "修改提款密码",
  "app.withdraw_pass.verification": "验证码",
  "app.withdraw_pass.verification_placeholder": "请输入验证码",
  "app.withdraw_pass.withdraw_pass": "输入密码",
  "app.withdraw_pass.withdraw_pass_dsc": "请输入密码",
  "app.withdrawal_inquiry.direction": "委托方向",
  "app.withdrawal_inquiry.name": "名称代码",
  "app.withdrawal_inquiry.price": "委托价格",
  "app.withdrawal_inquiry.quantity": "委托数量",
  "app.withdrawal_inquiry.status": "委托状态",
  "app.withdrawal_inquiry.time": "委托时间",
  "app.withdrawal_inquiry.title": "撤单查询",
  "app.withdrawal_inquiry.trade_direction": "多头/空头",
  "app.withdrawal_inquiry.unsold": "未成交数量",
  "app.withdrawalpass.password_not_identical": "密码不一致,请重新输入",
  "system.ActivityInfo.account_insufficient_funds": "你的账户资金不足",
  "system.ActivityInfo.already_experienced_free_funding": "你已经体验过免费配资了",
  "system.ActivityInfo.free_funding_application_failed": "免息配资申请失败",
  "system.ActivityInfo.free_funding_application_success": "免息配资申请成功",
  "system.AgentCreate.agent_already_opened": "代理已经开通",
  "system.AgentCreate.agent_opened_failed": "代理开通失败",
  "system.AgentCreate.agent_opened_success": "代理开通成功",
  "system.AgentInfo.account_balance_insufficient": "您的账户余额不足",
  "system.AgentInfo.amount_input_error": "您输入的金额有误",
  "system.AgentInfo.fund_transfer_failed": "资金划转失败",
  "system.AgentInfo.fund_transfer_success": "资金划转成功",
  "system.AgentInfo.no_promotion_code_contact_service": "没有推广码,请联系客服",
  "system.AgentInfo.transfer_amount_input_error": "您输入的划转金额有误",
  "system.AgentInfo.withdrawal_application_failed": "提现申请失败",
  "system.AgentInfo.withdrawal_application_success": "提现申请成功",
  "system.AutoClose.margin_call_fail": "追加保证金失败",
  "system.AutoClose.margin_call_sucesss": "追加保证金成功",
  "system.AutoClose.order_sell_fail": "委托出售失败",
  "system.AutoClose.order_sell_suceess": "委托出售成功",
  "system.AutoDepot.purchase_failed": "购买失败",
  "system.AutoDepot.purchase_success": "购买成功",
  "system.AutoDepot.sell_stock_failed": "出售股票失败",
  "system.AutoDepot.sell_stock_success": "出售股票成功",
  "system.Banks.account_holder_name_cannot_be_empty": "开户姓名不能为空",
  "system.Banks.account_holder_name_inconsistent_with_verification": "开户姓名与认证姓名不一致",
  "system.Banks.bank_branch_cannot_be_empty": "开户支行不能为空",
  "system.Banks.bank_card_number_cannot_be_empty": "银行卡号不能为空",
  "system.Banks.bank_card_number_format_error": "银行卡号格式错误",
  "system.Banks.bank_name_cannot_be_empty": "银行名称不能为空",
  "system.Banks.bank_not_open": "此银行暂未开放",
  "system.Banks.bind_failed": "绑定失败",
  "system.Banks.bind_success": "绑定成功",
  "system.Banks.first_real_name_verification_to_bind_bank_card": "首先实名认证才能绑定银行卡",
  "system.Banks.modify_failed": "修改失败",
  "system.Banks.modify_success": "修改成功",
  "system.CancelEntrust.batch_cancel_entrust_failed": "一键撤销委托失败",
  "system.CancelEntrust.batch_cancel_entrust_success": "一键撤销委托成功",
  "system.CancelEntrust.cancel_entrust_order_failed": "撤销委托订单失败",
  "system.CancelEntrust.cancel_entrust_order_not_exists": "撤销委托订单不存在",
  "system.CancelEntrust.cancel_entrust_order_success": "撤销委托订单成功",
  "system.CancelEntrust.cancel_order_success": "撤销委托订单成功",
  "system.CancelEntrust.entrust_order_id_not_exists": "委托订单标示不存在",
  "system.CancelEntrust.funding_info_not_exists": "配资信息不存在",
  "system.CancelEntrust.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.CancelEntrust.no_entrust_info": "没有委托信息",
  "system.CancelEntrust.position_info_not_exists": "持仓信息不存在",
  "system.CapitalHistory.funding_unique_id_not_passed": "没有传递配资唯一标示",
  "system.CapitalOperate.account_balance_insufficient": "你的账户余额不足",
  "system.CapitalOperate.account_balance_insufficient_exclamation": "你的账户余额不足！",
  "system.CapitalOperate.account_insufficient_funds": "你的账户资金不足",
  "system.CapitalOperate.additional_amount_format_error": "追加金额格式错误",
  "system.CapitalOperate.additional_amount_must_not_less_than_0": "追加金额不能小于0",
  "system.CapitalOperate.additional_funding_amount_must_be_100_multiple": "追加配资金额必须为100的倍数",
  "system.CapitalOperate.additional_funding_amount_must_not_less_than_0": "追加配金额不能必须小于0",
  "system.CapitalOperate.additional_funding_failed": "追加配资失败",
  "system.CapitalOperate.additional_funding_success": "追加配资成功",
  "system.CapitalOperate.additional_margin_failed": "追加保证金失败",
  "system.CapitalOperate.additional_margin_success": "追加保证金成功",
  "system.CapitalOperate.free_funding_cannot_withdraw_profit": "免息配资不能做利润提现！",
  "system.CapitalOperate.minimum_additional_amount": "最低追加资本额达到",
  "system.CapitalOperate.minimum_additional_funding_amount": "最低追加资本额达到",
  "system.CapitalOperate.please_enter_additional_amount": "请输入追加金额",
  "system.CapitalOperate.please_enter_additional_funding_amount": "请输入追加配资金额",
  "system.CapitalOperate.please_enter_withdrawal_amount": "请输入提取金额",
  "system.CapitalOperate.please_select_funding_order": "请选择配资订单",
  "system.CapitalOperate.profit_amount_insufficient": "盈利金额不足",
  "system.CapitalOperate.sorry_function_not_yet_open": "对不起，本功能还未开放！",
  "system.CapitalOperate.withdraw_profit_failed": "提取利润失败",
  "system.CapitalOperate.withdraw_profit_success": "提取利润成功",
  "system.CapitalOperate.withdrawal_amount_format_error": "提取金额格式错误",
  "system.CapitalOperate.withdrawal_amount_must_greater_than_0": "提取金额不能必须大于0",
  "system.CapitalWith.account_insufficient_funds": "你的账户资金不足",
  "system.CapitalWith.funding_application_failed": "配资申请失败",
  "system.CapitalWith.funding_application_success": "配资申请成功",
  "system.CapitalWith.funding_multiple_selection_error": "配资倍数选择错误",
  "system.CapitalWith.margin_must_be_100_multiple": "保证金为100的倍数",
  "system.CapitalWith.maximum_risk_margin": "较高风险保证金",
  "system.CapitalWith.minimum_risk_margin": "较低风险保证金",
  "system.CapitalWith.not_yet_open": "暂未开放",
  "system.CapitalWith.please_enter_risk_margin": "请输入风险保证金",
  "system.CapitalWith.please_select_funding_multiple": "请选择配资倍数",
  "system.CapitalWith.please_select_operation_type": "请选择操作类型",
  "system.Capital_model.funding_info_not_exists": "配资信息不存在",
  "system.Capital_model.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.Concern.add_to_watchlist_failed": "加入自选股失败",
  "system.Concern.add_to_watchlist_success": "加入自选股成功",
  "system.Concern.code_cannot_be_empty": "代码不能为空",
  "system.Concern.code_not_exists": "代码不存在",
  "system.Concern.remove_from_watchlist_failed": "删除自选失败",
  "system.Concern.remove_from_watchlist_success": "删除自选成功",
  "system.Concern.remove_from_watchlist_success_simple": "删除自选成功",
  "system.Concern.stock_not_yet_open": "暂未开放此股票",
  "system.ExactLog.profit_withdrawal": "利润提取",
  "system.Finance.account_insufficient_funds": "你的资金余额不足",
  "system.Finance.delete_operation_failed": "删除操作失败",
  "system.Finance.deleted": "已删除",
  "system.Finance.disagree_transaction_channel": "不同意交易渠道",
  "system.Finance.minimum_withdrawal_amount": "需要申请大于最低提款金额",
  "system.Finance.please_bind_bank_card": "请绑定银行卡",
  "system.Finance.please_enter_application_amount": "请输入申请金额",
  "system.Finance.please_enter_gxpay_id": "请输入您的GXPay ID",
  "system.Finance.please_enter_recharge_amount": "请输入充值资金",
  "system.Finance.please_enter_withdrawal_password": "请输入提现密码",
  "system.Finance.please_select_recharge_type": "请选择充值类型",
  "system.Finance.recharge_amount_must_be_100_multiple": "充值金额必须为100的倍数",
  "system.Finance.recharge_amount_must_be_integer": "充值金额必须为整数",
  "system.Finance.recharge_application_failed": "充值申请失败",
  "system.Finance.recharge_application_success": "充值申请成功",
  "system.Finance.recharge_confirmation": "充值确认",
  "system.Finance.recharge_confirmation_operation_failed": "充值确认操作失败",
  "system.Finance.recharge_type_selection_error": "充值类型选择错误",
  "system.Finance.withdrawal_amount_must_be_integer": "提现金额必须为整数",
  "system.Finance.withdrawal_application_failed": "提现申请失败",
  "system.Finance.withdrawal_application_success": "提现申请成功",
  "system.Finance.withdrawal_password_input_error": "提现密码输入错误",
  "system.Finance.withdrawal_password_not_set": "提现密码未设置",
  "system.FinanceDetail_model.is_repeat_no": "否",
  "system.FinanceDetail_model.is_repeat_yes": "是",
  "system.FinanceDetail_model.period_months_suffix": "个月",
  "system.FinanceDetail_model.period_weeks_suffix": "天",
  "system.FinanceFund.account_insufficient_balance": "账户余额不足",
  "system.FinanceFund.fund_transfer_in_failed": "资金转入失败",
  "system.FinanceFund.fund_transfer_in_success": "资金转入成功",
  "system.FinanceFund.fund_transfer_out_failed": "资金转出失败",
  "system.FinanceFund.fund_transfer_out_success": "资金转出成功",
  "system.FinanceFund.idle_money_manager_type_not_found": "没有找到闲钱管家类型",
  "system.FinanceFund.investable_balance_insufficient": "可投资余额不足",
  "system.FinanceFund.investment_fail": "投资失败",
  "system.FinanceFund.investment_sucess": "投资成功",
  "system.FinanceFund.no_settlement_document_selected": "没有选择结算单据",
  "system.FinanceFund.please_enter_amount": "请输入金额",
  "system.FinanceFund.please_enter_correct_amount": "请输入正确的金额",
  "system.FinanceFund.please_select_idle_money_manager_type": "请选择闲钱管家类型",
  "system.FinanceFund.settlement_document_not_found": "没有找到结算单据",
  "system.FinanceFund.settlement_failed": "结算失败",
  "system.FinanceFund.settlement_success": "结算成功",
  "system.FinanceFund.transferable_amount_insufficient": "可转金额不足",
  "system.FirstVoucher.already_signed_today_next_trading_day": "今天您已签到,下一个交易日再来！",
  "system.FirstVoucher.backend_bonus": "后台送",
  "system.FirstVoucher.batch_process_cash_failed": "批处理送现金失败！",
  "system.FirstVoucher.batch_process_voucher_failed": "批处理送代金券失败！",
  "system.FirstVoucher.capital_allocate": "的利息费",
  "system.FirstVoucher.deposit_bonus": "充值送",
  "system.FirstVoucher.event_bonus": "活动送",
  "system.FirstVoucher.first_deposit_bonus": "首充送",
  "system.FirstVoucher.first_recharge_batch_process_success": "首充活动批处理成功",
  "system.FirstVoucher.first_trade_bonus": "首次交易送",
  "system.FirstVoucher.real_name_bonus": "实名送",
  "system.FirstVoucher.sign_bonus": "注册送",
  "system.FirstVoucher.sign_in_bonus": "签到送",
  "system.FirstVoucher.signin_success_congratulations_voucher": "签到成功",
  "system.FirstVoucher.trial_bonus": "体验送",
  "system.FirstVoucher.voucher_bounus": "代金券使用",
  "system.FirstVoucher.welcome_signin_non_trading_day": "欢迎签到，今天是非交易日！",
  "system.FirstVoucher.winning_bonus": "中奖送",
  "system.ForgetPassword.new_password_cannot_be_empty": "新密码不能为空",
  "system.ForgetPassword.new_password_must_be_6_to_12_digits": "新密码必须为6-12位",
  "system.ForgetPassword.phone_number_format_incorrect": "手机号码格式不正确",
  "system.ForgetPassword.phone_number_incorrect": "手机号码不正确",
  "system.ForgetPassword.phone_number_not_registered": "此手机号码未注册",
  "system.ForgetPassword.phone_verification_code_incorrect": "手机验证码不正确",
  "system.ForgetPassword.please_enter_phone_verification_code": "请输入手机验证码",
  "system.ForgetPassword.please_enter_registration_phone_number": "请输入注册手机号码",
  "system.ForgetPassword.retrieve_login_password_failed": "找回登录密码失败",
  "system.ForgetPassword.retrieve_login_password_success": "找回登录密码成功",
  "system.ForgetPassword.two_password_inputs_inconsistent": "两次输入密码不一致",
  "system.FriendCoupon.friend_voucher_generation_complete": "好友代金券生成完毕",
  "system.HolidayFund.account_insufficient_balance": "账户余额不足",
  "system.HolidayFund.auto_transfer_modify_success": "自动转入修改成功",
  "system.HolidayFund.fund_transfer_failed": "资金转出失败",
  "system.HolidayFund.fund_transfer_in_failed": "资金转入失败",
  "system.HolidayFund.fund_transfer_in_success": "资金转入成功",
  "system.HolidayFund.fund_transfer_successful": "资金转出成功",
  "system.HolidayFund.holiday_account_not_found": "没找到节日宝账户",
  "system.HolidayFund.insufficient_investable_balance": "可投资余额不足",
  "system.HolidayFund.insufficient_transferable_amountt": "可转金额不足",
  "system.HolidayFund.investment_failed": "投资失败",
  "system.HolidayFund.investment_successful": "投资成功",
  "system.HolidayFund.no_settlement_document_found": "没有找到结算单据",
  "system.HolidayFund.no_settlement_document_selected": "没有选择结算单据",
  "system.HolidayFund.please_enter_amount": "请输入金额",
  "system.HolidayFund.please_enter_correct_amount": "请输入正确的金额",
  "system.HolidayFund.please_select_holiday_product": "请选择节日宝产品",
  "system.HolidayFund.product_not_found": "没有找到节日宝产品",
  "system.HolidayFund.settlement_failed": "结算失败",
  "system.HolidayFund.settlement_successf": "结算成功",
  "system.HolidayType_model.period_days_suffix": "天",
  "system.Home.no_activity": "没有活动！",
  "system.Home1.no_activity": "没有活动！",
  "system.KLine.illegal_input": "非法输入",
  "system.KLine.kline_type_not_specified": "没有指定K线类型！",
  "system.KLine.stock_code_not_specified": "没有指定股票代码！",
  "system.LoanLog.apply_finance": "追加配资",
  "system.LoanLog.apply_margin": "申请配资",
  "system.Login.information_error": "信息错误!",
  "system.Login.login_failed": "登录失败",
  "system.Login.login_success": "登录成功",
  "system.Login.no_permission": "你没有权限",
  "system.Login.phone_encryption_end": "电话加密结束",
  "system.Login.phone_or_password_error": "手机号码或登录密码错误",
  "system.Login.please_enter_login_password": "请输入登录密码",
  "system.Login.please_enter_phone_number": "请输入手机号码",
  "system.ManageLog.management_fee": "管理费",
  "system.Member.agent_opened_failed": "代理开通失败",
  "system.Member.agent_opened_success": "代理开通成功",
  "system.Member.already_real_name_verified": "已经实名认证",
  "system.Member.confirm_password_cannot_be_empty": "确认新密码不能为空",
  "system.Member.contact_service_complete_real_name_verification": "请联系客服完成实名认证后，再操作忘记密码。",
  "system.Member.email_format_error": "邮箱信格式错误",
  "system.Member.email_verification_code_error": "邮箱验证码错误",
  "system.Member.id_number_format_error": "身份证号格式错误",
  "system.Member.modify_failed": "修改失败",
  "system.Member.modify_phone_failed": "修改手机号码失败",
  "system.Member.modify_phone_success": "修改手机号码成功",
  "system.Member.modify_success": "修改成功",
  "system.Member.new_password_must_be_6_to_12_digits": "新密码必须6-12位",
  "system.Member.nickname_modify_failed": "昵称修改失败",
  "system.Member.nickname_modify_success": "昵称修改成功",
  "system.Member.operation_failed": "操作失败",
  "system.Member.operation_success": "操作成功",
  "system.Member.phone_number_format_error": "手机号码格式错误",
  "system.Member.phone_verification_code_error": "手机验证码错误",
  "system.Member.please_contact_service": "请联系客服",
  "system.Member.please_enter_email": "请输入邮箱信息",
  "system.Member.please_enter_email_verification_code": "请输入邮箱验证码",
  "system.Member.please_enter_id_number": "请输入身份证号",
  "system.Member.please_enter_new_password": "请输入新密码",
  "system.Member.please_enter_nickname": "请输入昵称",
  "system.Member.please_enter_phone_number": "请输入手机号码",
  "system.Member.please_enter_phone_verification_code": "请输入手机验证码",
  "system.Member.please_enter_real_name": "请输入真实名称",
  "system.Member.real_name_format_error": "真实名称格式错误",
  "system.Member.real_name_verification_application_failed": "申请实名认证失败",
  "system.Member.real_name_verification_application_success": "申请实名认证成功",
  "system.Member.two_password_inputs_inconsistent": "两次输入新密码不一致",
  "system.Member.user_already_used": "该用户已经被使用",
  "system.Member.verification": "验证",
  "system.NewsCenter.news_not_found": "查询新闻不存在",
  "system.NewsCenter.please_pass_news_unique_id": "请传递新闻唯一标示",
  "system.Notice_model.date_format": "Y年m月d日",
  "system.Nozzle.abnormal_login_please_relogin": "异常登录，请重新登录",
  "system.Nozzle.data_normal": "数据正规",
  "system.Nozzle.login_timeout_please_relogin": "登录超时，请重新登录",
  "system.Offline.disagree_transaction_channel": "不同意交易渠道",
  "system.Offline.fast_channel_temporarily_closed_contact_service": "快速通道暂时关闭,请联系在线客服",
  "system.Offline.order_failed_large_amount_contact_service": "下单失败，大额入款请联系在线客服",
  "system.Offline.please_contact_online_service": "请联系在线客服",
  "system.Offline.please_do_not_frequent_operation_wait_3min": "请勿频繁操作,请等待3分钟后重新尝试",
  "system.Offline.please_enter_recharge_amount": "请输入充值资金",
  "system.Offline.please_go_real_name_verification": "请前去实名认证",
  "system.Offline.please_select_fixed_amount": "请选择固定金额",
  "system.Offline.please_select_recharge_type": "请选择充值类型",
  "system.Offline.recharge_amount_must_be_100_multiple": "充值金额必须为100的倍数",
  "system.Offline.recharge_amount_must_be_integer": "充值金额必须为整数",
  "system.Offline.recharge_amount_must_be_over_100": "充值金额必须为100以上",
  "system.Offline.recharge_application_failed": "充值申请失败",
  "system.Offline.recharge_application_success_contact_service": "充值申请成功,尽快完成后续操作,联系客服吧",
  "system.Offline.recharge_type_selection_error": "充值类型选择错误",
  "system.PayBasic.recharge_application_failed": "充值申请失败",
  "system.PayBasic.recharge_application_success": "充值申请成功",
  "system.PayFive.abnormal_login_please_relogin": "异常登录，请重新登录",
  "system.PayFive.application_failed": "申请失败",
  "system.PayFive.application_success": "申请成功",
  "system.PayFive.bank_card_format_error": "银行卡号格式错误",
  "system.PayFive.login_timeout_please_relogin": "登录超时，请重新登录",
  "system.PayFive.payment_bank_not_open": "支付银行暂未开放",
  "system.PayFive.please_enter_recharge_amount": "请输入充值资金",
  "system.PayFive.please_select_payment_bank": "请选择支付银行",
  "system.PayFive.please_select_payment_bank_card": "请选择支付银行卡号",
  "system.PayFive.quick_pay_minimum_20_yuan": "快捷支付最少充值20元",
  "system.PayOne.abnormal_login_please_relogin": "异常登录，请重新登录",
  "system.PayOne.login_timeout_please_relogin": "登录超时，请重新登录",
  "system.PayOne.please_bind_bank_card": "请绑定银行卡",
  "system.PayOne.please_enter_recharge_amount": "请输入充值资金",
  "system.PayOne.please_real_name_verification": "请实名认证",
  "system.PayOne.recharge_application_failed": "充值申请失败",
  "system.PayOne.recharge_application_success": "充值申请成功",
  "system.PhoneCode.enter_registration_phone_number": "输入注册手机号码",
  "system.PhoneCode.name_or_id_number_error": "您输入的姓名或者身份证号码有错误",
  "system.PhoneCode.phone_number_already_registered": "手机号码已被注册",
  "system.PhoneCode.phone_number_format_incorrect": "手机号码格式不正确",
  "system.PhoneCode.phone_number_not_registered": "手机号码尚未注册",
  "system.PhoneCode.please_enter_correct_captcha": "请输入正确的图形验证码",
  "system.PhoneCode.please_try_again_later": "请稍后再尝试",
  "system.PhoneCode.send_failed": "发送失败",
  "system.PhoneCode.type_error": "类型错误",
  "system.PhoneCode.verification_code_sent_success": "你的验证码发送成功,请注意查收",
  "system.PhoneCode.verification_code_valid_5min_too_frequent": "验证码5分钟内有效,您发送过于频繁,请稍后尝试",
  "system.Protocols.please_enter_protocol_unique_id": "请输入协议唯一标示",
  "system.RealCancelEntrust.batch_cancel_entrust_failed": "一键撤销委托失败",
  "system.RealCancelEntrust.batch_cancel_entrust_success": "一键撤销委托成功",
  "system.RealCancelEntrust.cancel_entrust_order_failed": "撤销委托订单失败",
  "system.RealCancelEntrust.cancel_entrust_order_not_exists": "撤销委托订单不存在",
  "system.RealCancelEntrust.cancel_entrust_order_success": "撤销委托订单成功",
  "system.RealCancelEntrust.entrust_order_id_not_exists": "委托订单标示不存在",
  "system.RealCancelEntrust.funding_info_not_exists": "配资信息不存在",
  "system.RealCancelEntrust.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.RealCancelEntrust.no_entrust_info": "没有委托信息",
  "system.RealCancelEntrust.position_info_not_exists": "持仓信息不存在",
  "system.RealCapitalHistory.funding_unique_id_not_passed": "没有传递配资唯一标示",
  "system.RealCapitalOperate.account_balance_insufficient": "你的账户余额不足",
  "system.RealCapitalOperate.account_balance_insufficient_exclamation": "你的账户余额不足！",
  "system.RealCapitalOperate.additional_amount_format_error": "追加金额格式错误",
  "system.RealCapitalOperate.additional_amount_must_not_less_than_0": "追加金额不能小于0",
  "system.RealCapitalOperate.additional_funding_amount_must_be_100_multiple": "追加配资金额必须为100的倍数",
  "system.RealCapitalOperate.additional_funding_amount_must_not_less_than_0": "追加配金额不能必须小于0",
  "system.RealCapitalOperate.additional_funding_failed": "追加配资失败",
  "system.RealCapitalOperate.additional_funding_success": "追加配资成功",
  "system.RealCapitalOperate.additional_margin_failed": "追加保证金失败",
  "system.RealCapitalOperate.additional_margin_success": "追加保证金成功",
  "system.RealCapitalOperate.free_funding_cannot_withdraw_profit": "免息配资不能做利润提现！",
  "system.RealCapitalOperate.minimum_additional_amount": "最低追加金额{amount}元",
  "system.RealCapitalOperate.minimum_additional_funding_amount": "单次最低追加配资金额{amount}元",
  "system.RealCapitalOperate.please_enter_additional_amount": "请输入追加金额",
  "system.RealCapitalOperate.please_enter_additional_funding_amount": "请输入追加配资金额",
  "system.RealCapitalOperate.please_enter_withdrawal_amount": "请输入提取金额",
  "system.RealCapitalOperate.please_select_funding_order": "请选择配资订单",
  "system.RealCapitalOperate.profit_amount_insufficient": "盈利金额不足",
  "system.RealCapitalOperate.withdraw_profit_failed": "提取利润失败",
  "system.RealCapitalOperate.withdraw_profit_success": "提取利润成功",
  "system.RealCapitalOperate.withdrawal_amount_format_error": "提取金额格式错误",
  "system.RealCapitalOperate.withdrawal_amount_must_greater_than_0": "提取金额不能必须大于0",
  "system.RealCapitalWith.account_insufficient_funds": "你的账户资金不足",
  "system.RealCapitalWith.funding_application_failed": "配资申请失败",
  "system.RealCapitalWith.funding_application_success": "配资申请成功",
  "system.RealCapitalWith.funding_multiple_selection_error": "配资倍数选择错误",
  "system.RealCapitalWith.margin_must_be_100_multiple": "保证金为100的倍数",
  "system.RealCapitalWith.maximum_risk_margin": "最多风险保证金{amount}",
  "system.RealCapitalWith.minimum_risk_margin": "最少风险保证金{amount}",
  "system.RealCapitalWith.not_yet_open": "暂未开放",
  "system.RealCapitalWith.please_enter_risk_margin": "请输入风险保证金",
  "system.RealCapitalWith.please_select_funding_multiple": "请选择配资倍数",
  "system.RealCapitalWith.please_select_operation_type": "请选择操作类型",
  "system.RealCapital_model.funding_info_not_exists": "配资信息不存在",
  "system.RealCapital_model.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.RealDeal_model.market_price_prefix": "市价",
  "system.RealDeal_model.type_buy": "买入",
  "system.RealDeal_model.type_sell": "卖出",
  "system.RealEntrust_model.status_cancelled": "已撤销",
  "system.RealSettlement.entrust_orders_unprocessed_cannot_settle": "你有委托订单未处理，暂时无法结算",
  "system.RealSettlement.funding_settlement_failed": "配资结算失败",
  "system.RealSettlement.funding_settlement_success": "配资结算成功",
  "system.RealSettlement.position_orders_unprocessed_cannot_settle": "你有持仓订单未处理，暂时无法结算",
  "system.RealSettlement.settlement_cycle_minimum_two_days": "结算的周期最低为两天",
  "system.RealTradeBuy.buy_price_format_error": "购买价位格式错误",
  "system.RealTradeBuy.buy_quantity_cannot_be_empty": "购买数量不能为空",
  "system.RealTradeBuy.buy_quantity_format_error": "购买数量格式错误",
  "system.RealTradeBuy.buy_quantity_must_be_100_multiple": "购买数量为100的倍数",
  "system.RealTradeBuy.entrust_failed": "委托失败",
  "system.RealTradeBuy.entrust_success": "委托成功",
  "system.RealTradeBuy.funding_account_insufficient_funds": "您的配资账户资金不足",
  "system.RealTradeBuy.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.RealTradeBuy.please_enter_stock_code": "请输入股票代码",
  "system.RealTradeBuy.purchase_failed": "购买失败",
  "system.RealTradeBuy.selected_funding_info_not_exists": "选择配资信息不存在",
  "system.RealTradeSell.entrust_failed": "委托失败",
  "system.RealTradeSell.entrust_success": "委托成功",
  "system.RealTradeSell.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.RealTradeSell.please_enter_sell_quantity": "请输入出售数量",
  "system.RealTradeSell.please_enter_stock_code": "请输入股票代码",
  "system.RealTradeSell.position_info_not_exists": "持仓信息不存在",
  "system.RealTradeSell.selected_funding_info_not_exists": "选择配资信息不存在",
  "system.RealTradeSell.sell_price_format_error": "出售价位格式错误",
  "system.RealTradeSell.sell_quantity_format_error": "出售数量格式错误",
  "system.RealTradeSell.sell_quantity_must_greater_than_100": "出售数量必须大于100",
  "system.RealTradeSell.sell_stock_failed": "出售股票失败",
  "system.RealTradeSell.sell_stock_success": "出售股票成功",
  "system.RealTradeSell.stock_limit_down_trading_prohibited": "股票跌停板禁止交易",
  "system.RealTradeSell.stock_temporarily_unavailable": "股票暂时无法交易",
  "system.RealTradeSell.stock_today_trading_restricted": "此股票今日限制交易",
  "system.RealTradeSell.today_tradeable_quantity_insufficient": "今日可交易数量不足",
  "system.Recharge_model.operation_failed": "操作失败",
  "system.Recharge_model.operation_success": "操作成功",
  "system.Recharge_model.third_party_updated_confirmation": "请确认是否有第三方已经做了更新！",
  "system.RecommendShare.parameter_value_invalid": "参数值无效",
  "system.RecommendShare.please_enter_category": "请输入类别",
  "system.RecommendShare.recharge_insufficient": "充值不足",
  "system.Register.cash_voucher_already_used": "现金券已经被使用",
  "system.Register.cash_voucher_unavailable": "现金券不可用",
  "system.Register.login_password_format_error": "登录密码必须为6-12字母+数字",
  "system.Register.phone_number_already_registered": "手机号码已注册",
  "system.Register.phone_number_format_error": "手机号码格式错误",
  "system.Register.phone_number_mismatch": "手机号码和接受手机号码不符",
  "system.Register.phone_verification_code_error": "手机验证码错误",
  "system.Register.please_enter_login_password": "请输入登录密码",
  "system.Register.please_enter_phone_number": "请输入手机号码",
  "system.Register.please_enter_phone_verification_code": "请输入手机验证码",
  "system.Register.registration_failed": "注册失败",
  "system.Register.registration_success": "注册成功",
  "system.RiskControls.approching_warning_line": "元，离预警线",
  "system.RiskControls.away_from_liquidation_line": "元，离平仓线",
  "system.RiskControls.close_the_possition_balance": "进行平仓。余额",
  "system.RiskControls.close_to_the_liquidation": "离平仓线",
  "system.RiskControls.contract_balance": "合约余额",
  "system.RiskControls.current_market_capitalization": "元,当前市值",
  "system.RiskControls.dear_customer_your_account": "尊敬的客户,您的账户",
  "system.RiskControls.dear_customer_your_contract_number": "尊敬的客户,您的合约号",
  "system.RiskControls.gem_star_board_position_ratio_limit": "创业板或科创板单只股票持仓比例比不得超过100%",
  "system.RiskControls.individual_stock_position_exceeds_limit": "个人单支股票累计持仓超过限额",
  "system.RiskControls.insufficient_funds": "余额不足",
  "system.RiskControls.loan_amount": "借款额",
  "system.RiskControls.loss_exceeds_warning_line_trading_prohibited": "亏损超过预警线禁止交易",
  "system.RiskControls.margin": "元,保证金",
  "system.RiskControls.margin_call_required": "元，需要补保证金",
  "system.RiskControls.max_min_price_limit_exceeded": "最高最低买卖价格收盘价的9倍或9分之一",
  "system.RiskControls.maximum_price_trading_restricted": "最高价格限制交易",
  "system.RiskControls.member_account": "会员账户",
  "system.RiskControls.please_recharge_your_margin_to_avoid_losses": "元,请及时追加保证金以免系统自动平仓造成损失",
  "system.RiskControls.position_info_not_exists": "持仓信息不存在",
  "system.RiskControls.profit_loss": "元,盈亏",
  "system.RiskControls.right_to_close_positions_our_discretion": "元，依合同约定，我方将有权择机平仓，请及时关注",
  "system.RiskControls.stock_accumulated_over_50million_prohibited": "股票累计超过5000万,禁止交易",
  "system.RiskControls.stock_not_open_for_trading": "此股票暂未开放交易",
  "system.RiskControls.stock_temporarily_prohibited_contact_service": "此股票暂时禁止交易,请联系客服",
  "system.RiskControls.stock_today_trading_restricted": "此股票今日限制交易",
  "system.RiskControls.stock_trading_prohibited": "此股票禁止交易",
  "system.RiskControls.subject_to_contract_termination": "尊敬的客户,您的账户已欠费,将选择合约",
  "system.RiskControls.suspended_stock_trading_prohibited": "停牌股票禁止交易",
  "system.RiskControls.system_has_closed_and_settled": "已到期，系统按找约定进行平仓结算",
  "system.RiskControls.today_tradeable_quantity_insufficient": "今日可交易数量不足",
  "system.RiskControls.with_losses_exceeding": "元，亏损超过",
  "system.RiskControls.yuan": "元",
  "system.Settlement.entrust_orders_unprocessed_cannot_settle": "你有委托订单未处理，暂时无法结算",
  "system.Settlement.funding_settlement_failed": "配资结算失败",
  "system.Settlement.funding_settlement_success": "配资结算成功",
  "system.Settlement.position_orders_unprocessed_cannot_settle": "你有持仓订单未处理，暂时无法结算",
  "system.StockPrice.no_candlestick_type": "没有指定K线类型！",
  "system.StockPrice.no_symbol": "没有指定股票代码！",
  "system.Stocks.current_stock_market_closed_cannot_trade": "当前股票休市中无法交易",
  "system.Stocks.current_stock_trading_prohibited": "当前股票禁止交易",
  "system.Stocks.please_enter_correct_code": "请输入正确的代码",
  "system.Test.abnormal_login_please_relogin": "异常登录，请重新登录",
  "system.Test.data_normal": "数据正规",
  "system.Test.login_timeout_please_relogin": "登录超时，请重新登录",
  "system.TimebaoFund.account_insufficient_balance": "账户余额不足",
  "system.TimebaoFund.account_not_found": "没找到余额宝账户",
  "system.TimebaoFund.fund_transfer_in_failed": "资金转入失败",
  "system.TimebaoFund.fund_transfer_in_success": "资金转入成功",
  "system.TimebaoFund.fund_transfer_out_failed": "资金转出失败",
  "system.TimebaoFund.fund_transfer_out_success": "资金转出成功",
  "system.TimebaoFund.initialize_valid_principal": "初始化有效本金",
  "system.TimebaoFund.interest_calculation_failed": "利息计算失败",
  "system.TimebaoFund.interest_calculation_success": "利息计算成功",
  "system.TimebaoFund.modify_success": "修改成功",
  "system.TimebaoFund.no_balance": "没有余额",
  "system.TimebaoFund.no_interest": "没有利息",
  "system.TimebaoFund.please_enter_amount": "请输入金额",
  "system.TimebaoFund.please_enter_correct_amount": "请输入正确的金额",
  "system.TimebaoFund.transferable_amount_insufficient": "可转金额不足",
  "system.TimebaoFund.user_interest_already_calculated": "该用户利息计算已计算",
  "system.TradeBuy.account_abnormal_contact_service": "此账户异常，请联系客服",
  "system.TradeBuy.account_expired_buy_prohibited": "此账户到期，禁止买入",
  "system.TradeBuy.buy_price_error": "购买价格错误",
  "system.TradeBuy.buy_price_format_error": "购买价位格式错误",
  "system.TradeBuy.buy_quantity_cannot_be_empty": "购买数量不能为空",
  "system.TradeBuy.buy_quantity_format_error": "购买数量格式错误",
  "system.TradeBuy.entrust_failed": "委托失败",
  "system.TradeBuy.entrust_success": "委托成功",
  "system.TradeBuy.funding_account_insufficient_funds": "您的配资账户资金不足",
  "system.TradeBuy.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.TradeBuy.market_closed_cannot_trade": "休市时间,无法交易",
  "system.TradeBuy.minimum_buy_amount_limit": "最小买入额为（{amount}）港元",
  "system.TradeBuy.please_enter_stock_code": "请输入股票代码",
  "system.TradeBuy.please_enter_trade_quantity": "请输入交易数量",
  "system.TradeBuy.purchase_failed": "购买失败",
  "system.TradeBuy.purchase_success": "购买成功",
  "system.TradeBuy.stock_trading_suspended": "此股票暂停交易",
  "system.TradeSell.account_abnormal_contact_service": "此账户异常，请联系客服",
  "system.TradeSell.entrust_failed": "委托失败",
  "system.TradeSell.entrust_success": "委托成功",
  "system.TradeSell.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.TradeSell.individual_stock_position_exceeds_limit": "个人单支股票累计持仓超过限额",
  "system.TradeSell.loss_exceeds_warning_line_trading_prohibited": "亏损超过预警线禁止交易",
  "system.TradeSell.market_closed_cannot_trade": "休市时间,无法交易",
  "system.TradeSell.max_min_price_limit_exceeded": "最高最低买卖价格收盘价的9倍或9分之一",
  "system.TradeSell.please_enter_sell_quantity": "请输入出售数量",
  "system.TradeSell.please_enter_stock_code": "请输入股票代码",
  "system.TradeSell.please_enter_trade_quantity": "请输入交易数量",
  "system.TradeSell.position_info_not_exists": "持仓信息不存在",
  "system.TradeSell.purchase_failed": "购买失败",
  "system.TradeSell.sell_price_format_error": "出售价位格式错误",
  "system.TradeSell.sell_quantity_format_error": "出售数量格式错误",
  "system.TradeSell.sell_stock_failed": "出售股票失败",
  "system.TradeSell.sell_stock_success": "出售股票成功",
  "system.TradeSell.stock_not_open_for_trading": "此股票暂未开放交易",
  "system.TradeSell.stock_temporarily_unavailable": "股票暂时无法交易",
  "system.TradeSell.stock_today_trading_restricted": "此股票今日限制交易",
  "system.TradeSell.stock_trading_suspended": "此股票暂停交易",
  "system.TradeSell.today_tradeable_quantity_insufficient": "今日可交易数量不足",
  "system.WebNozzle.android_download": "安卓下载",
  "system.WebNozzle.apple_android_download": "苹果/安卓下载",
  "system.WebNozzle.ios_download": "Ios下载",
  "system.WebNozzle.wechat_official_account": "关注微信公众号",
  "system.WebNozzle.wechat_subscription_account": "关注微信订阅号",
  "system.Withdraw_model.fund_withdrawal": "资金提现",
  "system.Withdraw_model.status_completed": "已完成",
  "system.Withdraw_model.status_rejected": "已驳回",
  "system.Withdraw_model.status_under_review": "审核中",
  "system.YuebaoFund.account_insufficient_balance": "账户余额不足",
  "system.YuebaoFund.account_not_found": "没找到余额宝账户",
  "system.YuebaoFund.fund_transfer_in_failed": "资金转入失败",
  "system.YuebaoFund.fund_transfer_in_success": "资金转入成功",
  "system.YuebaoFund.fund_transfer_out_failed": "资金转出失败",
  "system.YuebaoFund.fund_transfer_out_success": "资金转出成功",
  "system.YuebaoFund.investment_balance_insufficient": "可投资余额不足",
  "system.YuebaoFund.modify_success": "修改成功",
  "system.YuebaoFund.no_settlement_document_selected": "没有选择结算单据",
  "system.YuebaoFund.please_enter_amount": "请输入金额",
  "system.YuebaoFund.please_enter_correct_amount": "请输入正确的金额",
  "system.YuebaoFund.settlement_document_not_found": "没有找到结算单据",
  "system.YuebaoFund.settlement_failed": "结算失败",
  "system.YuebaoFund.settlement_success": "结算成功",
  "system.YuebaoFund.transferable_amount_insufficient": "可转金额不足",
  "system.YuebaoFund.transferred_to_yuebao_failed": "转入余额宝理财失败",
  "system.YuebaoFund.transferred_to_yuebao_success": "已转入余额宝理财",
  "app.common.release_to_reload": "释放即可刷新...",
  "app.common.pull_to_reload": "下拉即可刷新…",
  "system.Member.please_contact_service_to_obtain_your_card_number": "请联系在线客服获取卡号",
  "system.Offline.success": "成功",
  "app.download.popup_testflight": "苹果防闪退版",
  "app.download.popup_vueandrod": "安卓专业版",
  "app.download.popup_applefree": "苹果免升级版",
  "app.download.popup_androidfree": "安卓免升级版",
  "app.download.popup_nativeapp_android": "安卓经典版",
  "app.download.popup_nativeapp_ios": "苹果经典版",
  "app.download.popup_dnzqandroid": "金牛证券安卓版",
  "app.download.popup_dnzqapple": "金牛证券苹果版",
  "app.download.popup_dnzqappletf": "金牛证券苹果TF",
  "app.download.popup_mac": "MAC桌面端",
  "app.download.popup_windows": "Windows桌面端",
  "app.agency_transfer_withdrawal.bind_bank": "还未绑定银行卡,请前去绑定银行卡才可提现",
  "app.channel_room.group_pw": "输入群组密码",
  "app.common.success": "成功",
  "app.members.recharge_application_success": "充值申请成功，尽快完成后续操作，联系客服吧",
  "app.recharge_info.repeat_submission": "请确认您已付款！重复提交会影响到账时间",
  "app.recharge_info.hint": "提示",
  "app.activities.title": "活动介绍",
  "app.gxpay.account": "Gxpay 账号",
  "app.gxpay.id": "Gxpay 余额",
  "app.gxpay.balance": "Gxpay 余额",
  "app.gxpay.buy": "买币",
  "app.gxpay.sell": "卖币",
  "app.gxpay.orderlist": "我的订单",
  "app.kline.name": "日K",
  "app.popupcontent.title": "充值指南",
  "app.members.platform_transfer": "资金划转 ",
  "app.platformtransfer.dnzq": "金牛证券",
  "app.platformtransfer.dnhk": "金牛港股",
  "app.platformtransfer.transfer_to": "划转至",
  "app.platformtransfer.currency": "美元",
  "app.platformtransfer.order_number": "订单号",
  "app.platformtransfer.central_system_number": "中央系统编号",
  "app.platformtransfer.transfer_amount": "划转额",
  "app.platformtransfer.account_balance": "账户余额",
  "app.platformtransfer.transfer_operation_type": "划转操作类型",
  "app.platformtransfer.accessed_platform": "访问平台",
  "app.platformtransfer.create_time": "创建时间",
  "app.platformtransfer.transfer_details": "资金划转明细",
  "system.platformtransfer.central_config": "稳定币配置已关闭，请联系客户服务",
  "system.platformtransfer.only_two_decimals": "仅允许 2 位小数",
  "app.trading.shares": "股 ",
  "app.trading.buy_button": "做多开仓 ",
  "app.trading.sell_button": "做多平仓 ",
  "app.trading.sell_button_short": "做空开仓 ",
  "app.trading.buy_button_short": "做空平仓 ",
  "app.cuc.amount_received": "到账金额 ",
  "app.cuc.dn_currency": "元 ",
  "app.cuc.hk_currency": "港元 ",
  "app.quotes.short_trading_stocks": "今日可做空股",
  "app.quotes.long_trading_stocks": "今日可做多股",
  "system.RiskControls.system_is_busy": "当前系统繁忙，请稍后再试 ",
  "system.TradeSell.stock_transaction_failed": "该股票交易失败",
  "system.platformtransfer.transfer_failed_account_holder_not_match": "资金划转失败--- 转入转出账号主体信息不匹配，划转失败",
  "app.createcapital.capital_direction": "配资仓位方向",
  "app.createcapital.longDirection": "做多交易",
  "app.createcapital.shortDirection": "做空交易",
  "app.trading.trading_activity_fee": "交易活动费",
  "system.TradeBuy.daily_limit_open_error": "该子账户已达到单天开仓次数",
  "system.TradeBuy.single_stock_ratio_error": "已超过单股持仓比例",
  "app.quotes.top_gainers": "涨幅榜 ",
  "app.quotes.top_losers": "跌幅榜 ",
  "app.quotes.market_cap": "市价榜 ",
  "app.quotes.24h_volume": "成交量榜 "
};



// WEBPACK FOOTER //
// ./src/lang/zh.js